import React from 'react';
import { ArrowRight, MessageCircle, ListChecks } from 'lucide-react';
import { Button } from '../ui/button';
import { usePreApproval } from '../../pages/LandingPage';

const FinalCTA = () => {
  const { openPreApproval } = usePreApproval();

  const scrollToFundingAssistant = () => {
    // Scroll to the Chat Section where the AI Funding Assistant is
    const fundingAssistantSection = document.getElementById('funding-assistant');
    if (fundingAssistantSection) {
      fundingAssistantSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section className="py-20 md:py-32 bg-slate-950 relative overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-gradient-to-b from-slate-900 to-slate-950" />
        <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-emerald-500/10 rounded-full blur-3xl" />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {/* Badge */}
        <div className="inline-flex items-center space-x-2 bg-emerald-500/10 border border-emerald-500/20 rounded-full px-4 py-2 mb-8">
          <span className="text-emerald-400 text-sm font-medium">Your Path to Growth Starts Here</span>
        </div>

        {/* Headline */}
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-6">
          Ready to Move Forward —{' '}
          <span className="text-emerald-400">or Just Want Clarity?</span>
        </h2>

        {/* Description */}
        <p className="text-lg text-slate-400 max-w-2xl mx-auto mb-10">
          Whether you're ready to begin or just exploring, we're here to guide — not push. 
          Choose your next step below.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Button
            onClick={openPreApproval}
            size="lg"
            data-testid="final-cta-start-btn"
            className="bg-emerald-500 hover:bg-emerald-400 text-slate-950 font-semibold px-8 py-6 text-lg rounded-xl transition-all hover:shadow-xl hover:shadow-emerald-500/25 hover:-translate-y-0.5 group"
          >
            Start at Step 1
            <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </Button>

          <Button
            size="lg"
            variant="outline"
            onClick={scrollToFundingAssistant}
            data-testid="ask-funding-guide-btn"
            className="border-slate-600 hover:border-slate-500 text-slate-300 hover:text-white px-8 py-6 text-lg rounded-xl transition-all hover:bg-slate-800/50 group"
          >
            <MessageCircle className="mr-2 w-5 h-5 group-hover:scale-110 transition-transform" />
            Ask the Funding Guide
          </Button>

          <a href="#steps">
            <Button
              size="lg"
              variant="ghost"
              className="text-slate-400 hover:text-emerald-400 hover:bg-transparent px-8 py-6 text-lg rounded-xl transition-colors group"
            >
              <ListChecks className="mr-2 w-5 h-5 group-hover:text-emerald-400 transition-colors" />
              Review My Next Step
            </Button>
          </a>
        </div>

        {/* Trust Statement */}
        <div className="mt-16 pt-8 border-t border-slate-800">
          <p className="text-slate-500 text-sm">
            <span className="text-slate-400">"I understand this. I know what happens next. I'm in control."</span>
            <br />
            — The feeling you should have after reviewing this page.
          </p>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
